export default __webpack_public_path__ + "static/media/D200_CoC.b911bf1b.pdf";